import { withInstall } from '@element-plus/utils'

import Tag from './src/tag.vue'

export const ElTag = withInstall(Tag)
export default ElTag

export * from './src/tag'
